import gql from 'graphql-tag';

export const FRAGMENT_FINANCIAL_ITEM_VALUATIONS = gql`
  fragment financialItemValuations on FinancialItemValuations {
    per
    pbr
  }
`;
